/**
 *  @namespace core/referer
 *
 *  Snapshot of the current "vue-router" instance [1]
 *
 *  @link https://router.vuejs.org/api/#route-object-properties
 */
import Console from '~/utils/lib/core/console'
import { always, equals, merge, or, over, pick, when, __, lensProp, pipe_ } from '~/utils/lib/core/prelude'

const console = new Console('store:referer')

export const useStore_core_referer = defineStore('core/referer', {
  state: () => ({
    /** @type {import('~/utils/lib/core/types_').Route_} */
    // @ts-ignore: UNSAFE coerce, pseudo maybe pattern
    route: null,
    isSnapshotMade: false,
  }),
  actions: {
    /// Mutations
    ///
    makeSnapshot(
      /** @type {import('~/utils/lib/core/types_').Route_} */ route
      ) {
      // @XXX "vue-router" dislikes `clone()`
      //   ↳ workaround: inferring an hampered `Route` by picking only used keys
      //     that do not throwed error (`maximum call stack`, `hasOwnProperty`
      //     issues`)
      this.route = pipe_(
        route,
        pick(
          [
            'path',
            'name',
            'hash@',
            'query',
            'params',
            'fullPath',
            // 'matched',
            'redirectFrom',
            // 'meta'
          ],
        ),
        // (?) micro managing default route redirection
        over(
          lensProp('path'),
          when(
            or(
              equals('/'),
              equals(''),
            ),
            always('/account/authentication')
          )
        ),
        // @ts-ignore: unsafe coerce for below problematic keys
        merge(
          __,
          {
            matched: [],  // `mempty::RouteRecord`
            meta: {},     // `memty::RouteMeta`
          }
        )
      )

      this.isSnapshotMade = true

      console.log('make snapshot on', this.route)
    },
  }
})
